


















$ = require 'jquery'

export default {
  name: 'game-trailer'

  props: ['label', 'aspect','youtubeId', 'maxWidth', 'image']

  data: -> clicked: false

  computed:
    styles: -> paddingBottom: (@aspect[1]/@aspect[0]*100)+'%'

    videoSource: ->
      src = 'https://www.youtube.com/embed/'+@youtubeId+'?rel=0&amp;showinfo=0'
      if @clicked
        src += '&autoplay=1'
      return src

  methods:
    onClick: (e) ->
      $(@$refs.cover).remove()
      @clicked = true
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/game/GameTrailer.vue